import type {
  NumberProfile,
  BabyNameRequest,
  BabyNameEntry,
  BabyNameResponse,
} from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { NumberProfile, BabyNameRequest, BabyNameEntry, BabyNameResponse };

export interface BabyNameNakshatraInfo {
  id: string;
  name_en: string;
  name_hi: string;
  number: number;
  rashi: string;
  ruler: string;
  deity: string;
}

export interface BabyNameNumerologyInfo {
  value: number;
  profile: NumberProfile;
}

// TODO(api-client): BabyNameNakshatraInfo / BabyNameNumerologyInfo — web-layer
// enrichments not present in backend schema; backend uses NumerologyInfo +
// NakshatraInfo shapes but they differ slightly from the UI-needed form.

export async function suggestBabyNames(data: BabyNameRequest): Promise<BabyNameResponse> {
  return apiRequest<BabyNameResponse>("/baby-names", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}
